<template>
    <footer class="relative mt-auto b-0 l-0 bg-light">
        <div class="container m-5 mx-auto w-full">
            <div class="row text-center justify-content-center w-full">
                <div class="col-6 col-lg-2">
                    <div class="fs-xs">
                        Soutěž Kasiopea probíhá za podpory
                        <a href="https://mff.cuni.cz" target="_blank">MFF UK</a>.
                    </div>
                    <div class="mt-2">
                        <a href="https://mff.cuni.cz" target="_blank">
                            <img
                                alt="Matfyz"
                                src="@/assets/sponsors/matfyz_barevne.png"
                                style="max-width: 120px"
                            />
                        </a>
                    </div>
                </div>
                <div class="col-6 col-lg-3">
                    <div class="fs-xs">
                        Realizace soutěže byla podpořena Ministerstvem školství, mládeže a
                        tělovýchovy.
                    </div>
                    <div class="mt-2">
                        <a href="https://www.msmt.cz/" target="_blank">
                            <img
                                alt="MŠMT"
                                src="@/assets/sponsors/MSMT.svg"
                                style="max-width: 120px"
                            />
                        </a>
                    </div>
                </div>
                <div class="col-12 col-lg-6 mt-4 mt-lg-0">
                    <div class="fs-xs">
                        Děkujeme našim sponzorům:
                    </div>
                    <div class="d-flex flex-wrap justify-content-center align-items-center">
                        <div v-for="sponsor in sponsors" :key="sponsor.name" class="flex-1">
                            <a :href="sponsor.link" target="_blank">
                                <img
                                    :src="sponsor.img"
                                    :alt="sponsor.name"
                                    class="px-2 py-1"
                                    style="max-width: 100px"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fs-xs row text-center justify-content-center w-full mt-4">
                <div>
                    Obsah stránek je k dispozici pod licencí Creative Commons
                    <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/cz/" target="_blank">
                        CC-BY-NC-SA 3.0
                    </a>
                    | Kontakt: <a href="mailto:kasiopea@matfyz.cz">kasiopea@matfyz.cz</a>
                    <if-logged-in>, <discord-link/></if-logged-in>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import { sponsors } from '@/config/web_config';
</script>

